import { useState } from 'react';
import Input from '@/components/Input';
import useUpdateJobSource from '../../api/useUpdateJobSource';
import { showErrorToast, showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';
import LinkedAccountEditFieldModal from './LinkedAccountEditFieldModal';

type Props = {
  isOpen: boolean;
  jobSourceId: number;
  currentLoginId: string | null;
  onClose: () => void;
  onSaved: () => Promise<unknown>;
};

export default function LinkedAccountEditLoginModal({
  isOpen,
  jobSourceId,
  currentLoginId,
  onClose,
  onSaved,
}: Props) {
  const [loginId, setLoginId] = useState(currentLoginId ?? '');
  const [loginPass, setLoginPass] = useState('');
  const updateJobSource = useUpdateJobSource();

  const handleSubmit = async () => {
    try {
      await updateJobSource.mutateAsync({
        id: jobSourceId,
        login_id: loginId,
        login_pass: loginPass,
      });
      await onSaved();
      showSuccessToast('アカウント情報を更新しました');
      onClose();
    } catch {
      showErrorToast('アカウント情報の更新に失敗しました');
    }
  };

  return (
    <LinkedAccountEditFieldModal
      isOpen={isOpen}
      title="ログイン情報を編集"
      isPending={updateJobSource.isPending}
      // 未登録の場合はパスワードも必須(新規作成)
      canSubmit={!!loginId && (!!currentLoginId || !!loginPass)}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col gap-xs">
        <label className="text-heading-xxs">ログインID</label>
        <Input
          value={loginId}
          onChange={(e) => setLoginId(e.target.value)}
          className="h-[42px] w-full"
          disabled={updateJobSource.isPending}
          autoComplete="new-password"
          autoCapitalize="none"
          spellCheck={false}
        />
      </div>
      <div className="flex flex-col gap-xs">
        <label className="text-heading-xxs">パスワード</label>
        <Input
          type="password"
          value={loginPass}
          onChange={(e) => setLoginPass(e.target.value)}
          className="h-[42px] w-full"
          placeholder={currentLoginId ? '新しいパスワードを入力' : 'パスワードを入力'}
          disabled={updateJobSource.isPending}
          autoComplete="new-password"
          autoCapitalize="off"
          spellCheck={false}
        />
      </div>
    </LinkedAccountEditFieldModal>
  );
}
